/**
 * Hook for subscribing to claim-code-specific WebSocket events
 *
 * This creates a subscription for a specific claim code, ensuring that
 * only events for that claim code are received by this client.
 */

import { useEffect } from 'react';
import { useWebSocket } from '../context/WebSocketContextUtil';
import { SubscriptionScope } from '../types/websocket';

/**
 * Subscribe to events for a specific claim code
 *
 * @param claimCode - The claim code to subscribe to
 * @param enabled - Whether the subscription is enabled (default: true)
 */
export function useClaimCodeSubscription(claimCode: string | null, enabled: boolean = true) {
  const { subscribe, unsubscribe } = useWebSocket();

  useEffect(() => {
    if (!enabled || !claimCode) return;

    const scope: SubscriptionScope = {
      type: 'claim_code',
      claimCode,
    };

    console.log(`🔔 Subscribing to claim code events: ${claimCode}`);
    subscribe(scope);

    return () => {
      console.log(`🔕 Unsubscribing from claim code events: ${claimCode}`);
      unsubscribe(scope);
    };
  }, [claimCode, enabled, subscribe, unsubscribe]);
}
